import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './exportStyle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ConfigurationSummary from 'components/DoorEntityConfigurationSummary'
import WireDistanceWarning from 'components/Wire/DistanceWarning'
import EthernetExpansionWarning from './ethernetExpansionWarning'
import DescriptionBuilder from 'components/DeviceDescription/DescriptionBuilder'
import { connectedDoorsSelector, currentDoorControllerSelector, exportWireDistanceSelector,
  exportWireEndDeviceSelector, connectedExpansionsSelector, expansionControllerExportParentSelector } from 'selectors/components'

const mapStateToProps = state => {
  const { connectedDoors, totalDistance } = connectedDoorsSelector(state)
  const { expansions, totalExpansionDistance } = connectedExpansionsSelector(state)
  const distanceResult = exportWireDistanceSelector(state)

  return {
    currentDoorController: currentDoorControllerSelector(state),
    doors: connectedDoors,
    totalDistance,
    expansions,
    totalExpansionDistance,
    networkCloset: exportWireEndDeviceSelector(state),
    wireDistance: distanceResult && distanceResult.distance,
    showWarning: distanceResult && distanceResult.showWarning,
    isImperial: state.ui.isImperial,
    parentController: expansionControllerExportParentSelector(state)
  }
}

class DoorControllerExportDetails extends React.Component {
  doorRow = door => (
    <div key={door.id} className={this.props.classes.door}>
      <div
        className={this.props.classes.doorIcon}
        style={{ background: door.color }}
      >
        <FontAwesomeIcon icon={['far', 'door-open']} style={{ margin: 'auto' }} />
      </div>
      <div style={{ flex: 1 }}>
        <span>{ door.name }</span>
        <div className={this.props.classes.distanceText}>
          Length: { door.distance }
        </div>
      </div>
    </div>
  )

  expansionRow = expansion => (
    <div key={expansion.id} className={this.props.classes.door}>
      <div
        className={this.props.classes.doorIcon}
        style={{ background: expansion.color }}
      >
        <FontAwesomeIcon icon={['far', 'microchip']} style={{ margin: 'auto' }} />
      </div>
      <div style={{ flex: 1 }}>
        <span>{ expansion.name }</span>
        <div className={this.props.classes.distanceText}>
          Length: { expansion.hasWire ? ` ${expansion.distance}` : ' —' }
          { expansion.wireIsEthernet && <EthernetExpansionWarning /> }
          { expansion.wireIsEthernet && expansion.showWarning && <WireDistanceWarning isImperial={this.props.isImperial} /> }
        </div>
      </div>
    </div>
  )

  renderParentInfo = _ => {
    const { parentController, currentDoorController: { model: { connection } }, wireDistance, classes } = this.props

    return (
      <div className={classes.wiringInfo} style={{ flex: '0 0 auto' }}>
        <strong>Main Controller:</strong>
        <span className={classes.row}>
          <div
            className={classes.doorIcon}
            style={{ background: parentController.color }}
          >
            <FontAwesomeIcon icon={['far', 'microchip']} style={{ margin: 'auto' }} />
          </div>
          { parentController.name }
        </span>
        { connection !== 'Ethernet' &&
          <span>
            Length: { wireDistance }
          </span>
        }
      </div>
    )
  }

  renderWiringInfo = _ => {
    const { networkCloset, wireDistance, showWarning, isImperial, classes } = this.props

    if (!networkCloset) return (
      <div className={classes.wiringInfo}>
        <strong>Network Connection:</strong>
        <em>No connection</em>
      </div>
    )

    return (
      <div className={classes.wiringInfo}>
        <strong>Network Connection:</strong>
        <span>
          <FontAwesomeIcon
            icon='server'
            className={classes.networkClosetIcon}
            style={{ color: networkCloset.color }}
          />
          { networkCloset.name }
        </span>
        <span>
          Length: { wireDistance }
          { showWarning && <WireDistanceWarning isImperial={isImperial} /> }
        </span>
      </div>
    )
  }

  render() {
    const { doors, totalDistance, expansions, totalExpansionDistance, currentDoorController, showWarning, parentController, classes } = this.props
    const { model: { text, image_url, allows_expansion, connection }, isExpansion } = currentDoorController

    const showExpansions = allows_expansion || expansions.length > 0
    const showExpansionWarning = expansions.some(expansion => expansion.wireIsEthernet)
    const showDistanceWarning = showWarning || (showExpansionWarning && expansions.some(expansion => expansion.wireIsEthernet && expansion.showWarning))

    return (
      <div className={classes.details}>
        <div className={classes.col}>
          <div className={classes.modelDetails}>
            { image_url && <img src={image_url} /> }
            Model:
            <span>{text}</span>
          </div>
          <span style={{ fontSize: '2.2rem', marginLeft: '.5rem' }}>Doors: {doors.length}</span>
          <span className={classes.distanceText} style={{ marginLeft: '.5rem' }}>Total Length: {totalDistance}</span>
          <div className={classes.listContainer}>
            { doors.map(this.doorRow) }
          </div>
          { showExpansions && <span style={{ fontSize: '2.2rem', marginLeft: '.5rem' }}>Expansion Controllers: {expansions.length}</span> }
          { showExpansions && <span className={classes.distanceText} style={{ marginLeft: '.5rem' }}>Total Length: {totalExpansionDistance}</span> }
          { showExpansions &&
            <div className={classes.listContainer}>
              { expansions.map(this.expansionRow) }
            </div>
          }
          { isExpansion && parentController && this.renderParentInfo() }
          { !(isExpansion && connection !== 'Ethernet') && this.renderWiringInfo() }
          { showExpansionWarning &&
            <div className={classes.ethernetExpansionWarning}>
              <FontAwesomeIcon icon='info-circle' />
              Not included in total length calculation
            </div>
          }
          { showDistanceWarning &&
            <div className={classes.wireLengthWarning}>
              <FontAwesomeIcon icon='exclamation-triangle' />
              Copper Ethernet cables should not exceed 328 ft (100 m)
            </div>
          }
          <DescriptionBuilder currentDevice={currentDoorController} type='doorController' isExport addPadding />
        </div>
        <div className={classes.col}>
          <ConfigurationSummary isExport isController />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(injectSheet(style)(DoorControllerExportDetails))



// WEBPACK FOOTER //
// ./src/components/DoorControllerDetails/exportDetails.js